import React from "react";
import store from "../store";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import ReactPlayer from "react-player";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import hideOnScroll from '../components/hideonscroll'
import MenuIcon from '@material-ui/icons/Menu';
import CountDown from "../components/CountDown2"
import CountDownBar from "../components/CountDownBar"
import { NotificationManager } from 'react-notifications';
import CircularProgress from '@material-ui/core/CircularProgress';
import Numpad from "../components/Numpad2"
import Modal from 'react-responsive-modal';
import { Link } from "react-router-dom";
import CompRank from './CompRank';
import TopBar from '../components/TopBar';
import Paper from '@material-ui/core/Paper';
import * as LHELPER from '../components/LessonHelper';
import { Redirect } from 'react-router-dom';
import ButtonBase from '@material-ui/core/ButtonBase';
import PowerIcon from '@material-ui/icons/PowerSettingsNew';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import { FIREBASE } from "../config/firebase";
import Divider from '@material-ui/core/Divider';
import * as STATIC from '../config/static';
import _ from 'lodash';
import moment from "moment";
import { isMobile } from "react-device-detect";
const DWIDTH = 1024;
const defaultSetting = {type:['LB_0'],
times:1,
rows:3,
showTime:6,
answerTime:10,
qCount:10,
maxNumber:10,
digits:1,
digits1:1,
digits2:1,
point:0,
percent:80,
displaySetting:0,
displayShow:0,
lessThan0:0,
largerThan:0,
roundNumber:0,
isReversed:0,
dr1:0,
dr2:0,
dba:1,
ssp:0,
}
if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE);
}
function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
function validatePhone(phone) {
  var re = /^([0-9]{6,20})$/;
  return re.test(phone);
};

const firestore = firebase.firestore();
//let IS_NAMING = window.location.hostname.toLowerCase()=='www1.namethegiraffe.com'?true:false;
//IS_NAMING = true;


var _this;

class CompHome extends React.Component {

  constructor(props) {
    super();
    _this = this;
    // let q1 = LHELPER.randomQuestionList(30,defaultSetting);
    // let q2 = LHELPER.randomQuestionList(10,{...defaultSetting,rows:9});
    let curSetIndex = 0;
    if(props.forceStart) {
      curSetIndex = props.forceStart.setIndex;
    }
    this.state={isPlaying:false,answerInput:"",showNumPad:false,showCountDown:false,startTime:0,nextTime:props.nextTime,showLock:true,selectedIndex:-1,selected:null,time:0,curSetIndex,curPage:0,sets:props.part.sets,showRank:false}
    _this.audio = new Audio("assets/sound/inner_bg.mp3");

  }
  updateDimensions() {
    //console.log(window.innerWidth);
    // _this.setState({
    //   innerWidth: window.innerWidth,
    //   innerHeight: window.innerHeight
    // });
  }
  componentDidMount() {
    const { curSetIndex,sets,nextTime} = _this.state;
    let time = sets[curSetIndex].time;
    let startTime = moment().valueOf();
    if(_this.props.forceStart) {
      time = _this.props.forceStart.remain;
      startTime = moment().subtract(parseInt(sets[curSetIndex].time)-_this.props.forceStart.remain,"seconds");
    }
    if(_this.props.partIndex!=0)
    {
      _this.setState({showRank:true});
      setTimeout(()=>{

        _this.setState({showRank:false})
      },nextTime*1000/2);
    }
    setTimeout(()=>{

      _this.setState({showCountDown:true,time:time,startTime:startTime,showLock:false})
    },nextTime*1000);
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  handleInputClick(value) {
    let q = _this.state.selected;
    //console.log(q);
    let answerInput = q.answer||"";
  //   let answerInput = _this.state.answerInput;
    if (value == 'Enter') {
      _this.setState({showNumPad:false})
    }
    else
      if (value != "-1") {
        if (answerInput.length < 7)
          answerInput += value;
        q.answer = answerInput;
      }
      else {
        if (answerInput.length > 0) {
          answerInput = answerInput.slice(0, -1);
          q.answer = answerInput;
        }
      }
      _this.forceUpdate()
  // _this.answerInput.focus();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    _this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }
  handleChange = name => event => {
    //event.preventDefault();
    _this.setState({ [name]: event.target.value });
  };
  handleChangeAnswer = name => event => {
    //console.log(event.target.value);
    //event.preventDefault();
    let q = _this.state.selected;
    q.answer = event.target.value;
    _this.setState({ [name]: event.target.value });

  };



  getName(fullname)
  {
    return _.last(fullname.split(' '));
  }
  endCountDown() {
    const { curSetIndex,sets,startTime } = _this.state;


    let remain = Number(sets[curSetIndex].time)*1000- (moment().valueOf()-moment(startTime).valueOf());

    if(curSetIndex<sets.length-1)
    {

      if(_this.props.onSetEnd)
      {
        _this.props.onSetEnd(_this.state.sets[curSetIndex].questions,curSetIndex,remain<0?0:remain);
      }
      _this.setState({curSetIndex:curSetIndex+1,showNumPad:false,nextTime:_this.props.part.time,curPage:0,showLock:true,showCountDown:false,showRank:true},()=>setTimeout(()=>{
        _this.setState({showCountDown:true,time:sets[curSetIndex].time,startTime:moment().valueOf(),showLock:false,showRank:false})
      },_this.props.part.time*1000))
    }
    else {
      _this.setState({curSetIndex:curSetIndex+1,nextTime:0,showLock:true,showCountDown:false});
      if(_this.props.onSetEnd)
      {
        _this.props.onSetEnd(_this.state.sets[curSetIndex].questions,curSetIndex,remain<0?0:remain,true);
      }
      STATIC.NotificationManager.success("Chúc mừng bạn đã hoàn thành phần thi")
    }

    //console.log("end coutdown");
    //_this.confirmAnswer();
  }
  finishSet() {
    const { curSetIndex,sets } = _this.state;
    for(let q of _this.state.sets[curSetIndex].questions)
    {
      if(!q.answer||q.answer.length==0)
      {
        return STATIC.NotificationManager.error("Bạn hãy trả lời hết câu hỏi");
      }
    }
    _this.endCountDown();
  }
  handleKeypress = event => {

    // const { curSetIndex,sets,curPage } = _this.state;
    // let splitScreen = 1;
    // let limit = 13;
    // let totalPage = 0;
    // let startIndex = 0;
    // if(curSetIndex<this.state.sets.length)
    // {
    //   let quest = this.state.sets[curSetIndex].questions[0];
    //   if(quest.numbers.length<=4)
    //   {
    //     splitScreen = 2;
    //     limit = 25;
    //   }
    //   totalPage = Math.ceil(this.state.sets[curSetIndex].questions.length/limit);
    //   startIndex = limit*curPage;
    // }
    // if (event.key === "Enter") {
    //   //const { curSetIndex,sets } = _this.state;
    //   let rIndex = _this.state.selectedIndex;
    //   if(_this.state.sets[curSetIndex].questions.length-1>rIndex)
    //   {
    //     rIndex=rIndex+1;
    //     if(rIndex>=startIndex+limit)
    //     _this.setState({curPage:curPage+1});
    //     let oq = this.state.sets[curSetIndex].questions[rIndex];
    //     _this.setState({selectedIndex:rIndex,selected:oq,answerInput:oq.answer||""})
    //   }
    //
    //   //_this.confirmAnswer();
    // }

  }
  handleKeydown = e => {
//console.log("test",e.keyCode);
const { curSetIndex,sets,curPage } = _this.state;
let splitScreen = 1;
let limit = 13;
let totalPage = 0;
let startIndex = 0;
if(curSetIndex<this.state.sets.length)
{
  let quest = this.state.sets[curSetIndex].questions[0];
  if(quest.numbers.length<=4)
  {
    splitScreen = 2;
    limit = 25;
  }
  totalPage = Math.ceil(this.state.sets[curSetIndex].questions.length/limit);
  startIndex = limit*curPage;
}
    if(e)
    {

      if(e.keyCode=="13")
      {
          //const { curSetIndex,sets } = _this.state;
          let rIndex = _this.state.selectedIndex;
          if(_this.state.sets[curSetIndex].questions.length-1>rIndex)
          {
            rIndex=rIndex+1;
            if(rIndex>=startIndex+limit)
            _this.setState({curPage:curPage+1});
            let oq = this.state.sets[curSetIndex].questions[rIndex];
            _this.setState({selectedIndex:rIndex,selected:oq,answerInput:oq.answer||""})
          }

          //_this.confirmAnswer();

      }
      else
      if (e.keyCode == '38') {
             // up arrow
         }
         else if (e.keyCode == '40') {
             // down arrow
         }
         else if (e.keyCode == '37') {
            // left arrow

            let rIndex = _this.state.selectedIndex;
            if(rIndex>0)
            {
              rIndex=rIndex-1;
              if(rIndex<startIndex)
              _this.setState({curPage:curPage-1});
              let oq = this.state.sets[curSetIndex].questions[rIndex];
              _this.setState({selectedIndex:rIndex,selected:oq,answerInput:oq.answer||""})
            }
            e.preventDefault();
         }
         else if (e.keyCode == '39') {
           const { curSetIndex,sets } = _this.state;
           let rIndex = _this.state.selectedIndex;
           if(_this.state.sets[curSetIndex].questions.length-1>rIndex)
           {
             rIndex=rIndex+1;
             if(rIndex>=startIndex+limit)
             _this.setState({curPage:curPage+1});
             let oq = this.state.sets[curSetIndex].questions[rIndex];

             _this.setState({selectedIndex:rIndex,selected:oq,answerInput:oq.answer||""})
           }
           e.preventDefault();
            // right arrow
         }
         else {
           let new_value = (_this.state.answerInput||"")+e.key;
           if(e.keyCode==8)
           {
             if((_this.state.answerInput||"").length>0)
             new_value = (_this.state.answerInput||"").slice(0, -1);
           }
           //console.log(parseF)
           if(isNaN(new_value)&&new_value!="-")
           {
             e.preventDefault();
           }
         }
    }

  }

  render() {
    const { classes,t,comp } = this.props;
    const { loading,showRank, wWidth, wHeight,showNumPad,curSetIndex,curPage,time,showCountDown,showLock,nextTime,answerInput } = this.state;
  //  console.log("aaa",showNumPad)
    let width = 1024;
    let height = 640;

    // if (wWidth < width) {
    //   width = wWidth;
    // }

      height = wHeight;

    let sRate = 1024 / 640;
    let tRate = 1453 / 750;
    let bRate = 615 / 47;
    let mRate = 83 / 372;
    let bbRate = 27/43;
    let lockRate = 268/354;
    let locksRate = 268/1024;
    let asRate = 121 / 2048;
    let tsRate = 1453/2048;
    let bsRate = 615/2048;
    let bbsRate = 27/2048;
    let msRate = 83/2048;

    //if (width / wHeight > sRate) {
      width = wHeight * sRate;
      if(width>wWidth)
      {
          width = wWidth;
          height = width/sRate;
      }
    let tWidth = width*tsRate;
    let tHeight = tWidth/tRate;
    let bWidth = width*bsRate;
    let bHeight = bWidth/bRate;
    let bbWidth = width*bbsRate;
    let bbHeight = bbWidth/bbRate;
    let mWidth = width*msRate;
    let mHeight = mWidth/mRate;
    let spaceWidth = width*33/2048;
    let lockWidth = width*locksRate;
    let lockHeight = lockWidth/lockRate;
    //}
    let fNQ = width * 0.05;
    let fBig = width * 0.07;
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let fSmaller = width * 0.015;
    let ACCOUNTCOMP = store.getState().ACCOUNTCOMP;
    let SOUND = store.getState().SOUND;

    if (!ACCOUNTCOMP) {

      return (<Redirect to='/competition_login' />);
    }

    let splitScreen = 1;
    let limit = 13;
    let totalPage = 0;
    let startIndex = 0;
    if(curSetIndex<this.state.sets.length)
    {
      let quest = this.state.sets[curSetIndex].questions[0];
      if(quest.numbers.length<=4)
      {
        splitScreen = 2;
        limit = 25;
      }
      totalPage = Math.ceil(this.state.sets[curSetIndex].questions.length/limit);
      startIndex = limit*curPage;
    }

    //console.log(isMobile);



    //console.log(totalPage,startIndex);
    //let bWidth = STATIC.calSize(512, DWIDTH, width);
    //console.log(ACCOUNT);
    //#12450b
    if(showRank)
    {
      return <CompRank round={_this.props.roundIndex} comp={_this.props.comp} />
    }
    return (
      <div className={classes.root} style={{backgroundImage:comp&&comp.bg_main&&comp.bg_main.length>0?("url('"+comp.bg_main+"')"):"url('assets/comp/bg_comp.png')"}}>
        <div className={classes.middle} >




            <div className={classes.square} style={{maxWidth:width, width: width,height:height,backgroundImage: comp&&comp.bg_see&&comp.bg_see.length>0?("url('"+comp.bg_see+"')"):"url('assets/comp/bg_wait.png')",
            backgroundPosition: "center center",
            WebkitBackgroundSize: "100% 100%",
            backgroundSize: "100% 100%",position:'relative' }} elevation={4}>
            <Grid container direction="row" alignItems="center" justify="center">
              <Grid item xs={12}  alignItems="center" justify="center" style={{display:"flex", marginTop: STATIC.calSize(100, DWIDTH, width) }}>
                {showCountDown&&<CountDownBar width={width}  second={time} isEnd={()=>{}}  />}

              </Grid>
            </Grid>
              <div style={{paddingTop:STATIC.calSize(10, DWIDTH, width) + 'px '}}>{" "}</div>
                {!showLock?<div style={{  flexGrow: 1, position: 'relative' }}>

                  <div style={{ display: 'flex', height: tHeight,flexDirection:'column', justifyContent: 'center', alignItems: 'center' }}>
                  <div  style={{width: tWidth,height:tHeight,position:'relative' }} elevation={4}>
                  <div style={{display:'flex',flexDirection:'row', justifyContent: 'center',height:tHeight/splitScreen, alignItems: 'center'}}>
                      {_.cloneDeep(this.state.sets[curSetIndex].questions).splice(startIndex,13).map((q,index)=>{
                        let rIndex = startIndex+index;
                        //console.log(_this.state.selectedIndex,rIndex);
                        let selected = _this.state.selectedIndex==rIndex;
                        let oq = this.state.sets[curSetIndex].questions[rIndex];
                        return (<div key={rIndex} onClick={()=>this.setState({showNumPad:true,selectedIndex:rIndex,selected:oq,answerInput:oq.answer},()=>{if(!isMobile)_this.answerInput.focus()})} style={{display:'flex',zIndex:selected?9998:0,marginLeft:index!=0?spaceWidth:0,flexDirection:'column',width:mWidth}}>
                            <div style={{width:mWidth,height:mWidth*85/83,position:'relative'}}>
                              <img src='assets/comp/m_top.png'  style ={{width:mWidth,height:mWidth*85/83}}/>
                              <div style={{fontSize:fSmall,textAlign:'center',color:'black',position:'absolute',width:mWidth,top:STATIC.calSize(0, DWIDTH, width),left:STATIC.calSize(0, DWIDTH, width)}}>{rIndex+1}</div>
                            </div>
                            <div style={{width:mWidth,position:'relative',height:(tHeight/splitScreen-(mWidth*85/83)-(mWidth*104/83))}}>
                              <img src='assets/comp/m_mid.png'  style ={{width:mWidth,height:(tHeight/splitScreen-(mWidth*85/83)-(mWidth*104/83))}}/>
                              <div style={{display:'flex',flexDirection:'column',position:'absolute',top:0,left:0,right:0,bottom:0}}>
                                {q.numbers.map((n,index2)=>{
                                  return <div key={index2} style={{textAlign:'center',width:mWidth,fontSize:fSmaller,color:'black',fontWeight:'bold'}}>{n}</div>
                                })}



                              </div>
                            </div>
                            <div  style={{width:mWidth,height:mWidth*104/83,position:'relative'}}>
                              <img src='assets/comp/m_bot.png'  style ={{width:mWidth,height:mWidth*104/83}}/>
                              <div style={{fontSize:fSmaller,textAlign:'center',color:'black',position:'absolute',
                                width:mWidth,top:STATIC.calSize(20, DWIDTH, width),left:STATIC.calSize(0, DWIDTH, width)}}>{q.answer}</div>
                            </div>
                        </div>)
                      })}
                  </div>
                  {splitScreen==2&&<div style={{display:'flex',flexDirection:'row', justifyContent: 'center',height:tHeight/splitScreen, alignItems: 'center'}}>
                      {_.cloneDeep(this.state.sets[curSetIndex].questions).splice(startIndex+13,12).map((q,index)=>{
                        //let rIndex = page*
                        let rIndex = startIndex+13+index;
                        let selected = _this.state.selectedIndex==rIndex;
                        let oq = this.state.sets[curSetIndex].questions[rIndex];
                        return (<div onClick={()=>this.setState({showNumPad:true,selectedIndex:rIndex,selected:oq,answerInput:oq.answer},()=>{if(!isMobile)_this.answerInput.focus()})} key={rIndex} style={{display:'flex',zIndex:selected?9998:0,marginLeft:index!=0?spaceWidth:0,flexDirection:'column',width:mWidth}}>
                            <div style={{width:mWidth,height:mWidth*85/83,position:'relative'}}>
                              <img src='assets/comp/m_top.png'  style ={{width:mWidth,height:mWidth*85/83}}/>
                              <div style={{fontSize:fSmall,textAlign:'center',color:'black',position:'absolute',width:mWidth,top:STATIC.calSize(0, DWIDTH, width),left:STATIC.calSize(0, DWIDTH, width)}}>{rIndex+1}</div>
                            </div>
                            <div style={{width:mWidth,position:'relative',height:(tHeight/splitScreen-(mWidth*85/83)-(mWidth*104/83))}}>
                              <img src='assets/comp/m_mid.png'  style ={{width:mWidth,height:(tHeight/splitScreen-(mWidth*85/83)-(mWidth*104/83))}}/>
                              <div style={{display:'flex',flexDirection:'column',position:'absolute',top:0,left:0,right:0,bottom:0}}>
                                {q.numbers.map((n,index2)=>{
                                  return <div key={index2} style={{textAlign:'center',width:mWidth,fontSize:fSmaller,color:'black',fontWeight:'bold'}}>{n}</div>
                                })}



                              </div>
                            </div>
                            <div style={{width:mWidth,height:mWidth*104/83,position:'relative'}}>
                              <img src='assets/comp/m_bot.png'  style ={{width:mWidth,height:mWidth*104/83}}/>
                              <div style={{fontSize:fSmaller,textAlign:'center',color:'black',position:'absolute',
                                width:mWidth,top:STATIC.calSize(20, DWIDTH, width),left:STATIC.calSize(0, DWIDTH, width)}}>{q.answer}</div>
                            </div>
                        </div>)
                      })}
                  </div>}


                  </div>

                </div>
              </div>:false}
              <div style={{width,position:'absolute',bottom:STATIC.calSize(1, DWIDTH, width),left:STATIC.calSize(0,DWIDTH, width),display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
                <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center' }}>{ACCOUNTCOMP.id}</div>
              </div>
              <div style={{width,position:'absolute',bottom:STATIC.calSize(50, DWIDTH, width),left:STATIC.calSize(0,DWIDTH, width),display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
                <div className="comp_text_gradient"  style={{fontSize:fBig,whiteSpace: "pre",textAlign:'center',lineHeight:STATIC.calSize(640 , DWIDTH, width)*377/1427/3+"px" }}>{"Nhìn tính"}</div>

              </div>
              <div  style={{position:'absolute',top:STATIC.calSize(11, DWIDTH, width),left:STATIC.calSize(375,DWIDTH, width),width:width*574/2048,height:(width*574/2048)*377/1427,backgroundImage:"url('assets/comp/square_name.png')",backgroundSize:"100% 100%", textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center' }}>
                <div className="comp_text_gradient"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:0.8}}>{comp?comp.name:"SUPERBRAIN\nSPEED MATH"}</div>
              </div>
              <div style={{position:'absolute',top:STATIC.calSize(35, DWIDTH, width),right:STATIC.calSize(70,DWIDTH, width)}}>
                <div className="comp_text_gradient"  style={{fontSize:fTitle,whiteSpace: "pre",textAlign:'center',lineHeight:fBig+"px" }}>{showCountDown&&<CountDown size={fTitle} second={time} isEnd={this.endCountDown} />}</div>
              </div>
              <div style={{position:'absolute',top:STATIC.calSize(35, DWIDTH, width),left:STATIC.calSize(70,DWIDTH, width)}}>
                <div className="comp_text_gradient2"  style={{fontSize:fNQ,whiteSpace: "pre",textAlign:'center',lineHeight:fBig+"px" }}>{"SET 0"+(curSetIndex+1)}</div>
              </div>
              {curPage!=totalPage-1&&<ButtonBase onClick={()=>this.setState({curPage:curPage+1})} style={{position:'absolute',bottom:STATIC.calSize(90, DWIDTH, width),right:STATIC.calSize(70,DWIDTH, width)}}>
                <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:1 }}>{"NEXT >>"}</div>
              </ButtonBase>}
              {!showLock&&showCountDown&&<ButtonBase onClick={()=>this.finishSet()} style={{position:'absolute',paddingLeft:STATIC.calSize(20, DWIDTH, width),paddingRight:STATIC.calSize(20, DWIDTH, width), textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center',backgroundImage:"url('assets/comp/button.png')",backgroundSize:"100% 100%",top:STATIC.calSize(90, DWIDTH, width),right:STATIC.calSize(70,DWIDTH, width)}}>
                <div className="comp_text_gradient"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:1 }}>{"Hoàn Thành"}</div>
              </ButtonBase>}
              {curPage!=0&&<ButtonBase onClick={()=>this.setState({curPage:curPage-1})} style={{position:'absolute',bottom:STATIC.calSize(55, DWIDTH, width),left:STATIC.calSize(50,DWIDTH, width)}}>
                <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:1 }}>{"<< Back"}</div>
              </ButtonBase>}
              {showNumPad&&<div style={{position:'absolute',top:0,left:0,right:0,bottom:0,display:'flex',justifyContent: 'center', alignItems: 'center'}}>

                <div onClick={()=>this.setState({showNumPad:false,selectedIndex:-1,selected:null})} style={{position:'absolute',top:0,left:0,right:0,bottom:0,width:'100%',height:'100%',backgroundColor:'rgba(0,0,0,0.5)'}}>

                </div>
                <input ref={(input) => { this.answerInput = input; }} type="text" onKeyPress={this.handleKeypress} tabIndex={0} onKeyDown={this.handleKeydown} onChange={this.handleChangeAnswer("answerInput")} value={answerInput} style={{zIndex:-9999, width:0,height:0 }} />
                <div style={{position:"absolute",right:20,bottom:20}}>{isMobile&&<Numpad width={width * 0.3} handleClick={this.handleInputClick} />}</div>
              </div>}
              {showLock&&<div style={{position:'absolute',top:0,left:0,right:0,bottom:0,display:'flex',flexDirection:"column",justifyContent: 'center', alignItems: 'center'}}>
              <div  style={{position:'absolute',top:0,left:0,right:0,bottom:0,width:'100%',height:'100%',backgroundColor:'rgba(0,0,0,0.5)'}}>

              </div>
                <img src='assets/comp/lock.png'  style ={{width:lockWidth,height:lockHeight}}/>
                {nextTime!=0&&<CountDown size={fTitle} second={nextTime} isEnd={()=>{}} />}
              </div>}
            </div>

        </div>
        <div style={{position:'fixed',bottom:STATIC.calSize(5, DWIDTH, width),left:STATIC.calSize(5,DWIDTH, width)}}>
          <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center' }}>Online: {this.props.online}</div>

        </div>




      </div>
    );
  }
}

CompHome.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles2)(STATIC.translate('common')(CompHome));
